module.exports = __webpack_public_path__ + "static/img/design.c692137c.png";